
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark" >
        <button class="navbar-toggler nav mb-1">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent" >
            <ul class="navbar-nav" style=" float: left;">
                <li class="nav-item p-1 rounded">
                    <a class="nav-link smooth-scroll text-uppercase" href="#"><i class='bx bx-home'></i>Home
                    </a>
                </li>
                <li class="nav-item p-1 rounded">
                    <a class="nav-link js-scroll-trigger smooth-scroll text-uppercase" href="cv"> <i
                            class='bx bx-file-blank'></i>Resume</a>
                </li>

                <li class="nav-item p-1 rounded">
                    <a class="nav-link js-scroll-trigger smooth-scroll text-uppercase" href="projects"> <i
                            class='bx bx-book-content'></i>Projects</a>
                </li>

                <li class="nav-item p-1 rounded">
                    <a class="nav-link js-scroll-trigger smooth-scroll text-uppercase" href="blogs"><i
                            class='bx bx-message-square-edit'></i>Blogs</a>
                </li>
                <li class="nav-item p-1 rounded">
                    <a class="nav-link js-scroll-trigger smooth-scroll text-uppercase" href="contact"><i
                            class='bx bx-envelope'></i>Contact</a>
                </li>

            </ul>
        </div>
    </nav>
